/**
|--------------------------------------------------
| Localization
|--------------------------------------------------
*/
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';

// Enable once multilanguage support required
// import en from './en.locale.js';
import ja from './ja.locale.js';

import 'dayjs/locale/ja';

dayjs.extend(localeData);
dayjs.locale('ja');

/**
 * Available languages
 * @type {Array[{name: string, code: string}]} Languages available for use
 */
export const languages = [
  // { name: 'English', code: 'en' },
  { name: '日本語', code: 'ja' }
];

/**
 * Default language key
 */
export const defaultLanguage = 'ja';

/**
 * Key to use for storing the locale in localStorage
 */
export const localeStorageKey = 'locale';

/**
 * Translations for each language
 * @type {{[string]: Object}} Translations to render
 */
export const translations = {
  // en,
  ja
};

/**
 * Report missing translation keys to sentry
 */
export const onMissingTranslation = () => {
  // Sentry.captureMessage(`Missing translation key for ${translationId}`);
  return '';
};

/**
 * Assumed user language
 */
// const language =
//   localStorage.getItem(localeStorageKey) ||
//   window.navigator.userLanguage ||
//   window.navigator.language ||
//   defaultLanguage;

/**
 * Corresponding language code
 */
// let languageCode = language.split('-')[0];

/**
 * Check if supported language code
 */
// if (!languages.find(lang => lang.code === languageCode)) {
//   console.warn('Unsupported language');
//   languageCode = defaultLanguage;
// }
